import React from 'react';
import { Truck, Users, X, Star, Upload, ArrowBigLeft } from 'lucide-react';
import '../../../../../styles/components/vehicle-register.scss';
import i18n from '../../../../../i18n';
import { AddDriver } from './AddDriver';
import { getLoggedUser } from '../../../../../state/user';

class VehicleRegistration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'non-opal',
      showModal: false,
      vehicleType: '',
      vehicleNumber: '',
      systemId: '',
      modelMake: '',
      capacity: '',
      registrationId: '',
      registrationCopy: null,
      vehiclePhotos: [
        {
          id: 1,
          url: '',
        },
        {
          id: 2,
          url: '',
        },
      ],
      assignedDrivers: [
        {
          id: 1,
          name: '',
          code: '',
          isPrimary: true,
          avatar: '',
        },
      ],
      selectedDriver: {
        name: '',
        photo: '',
        contact: '',
        licenseNo: '',
        validityDate: '',
        idNo: '',
        idCopy: null,
      },
      activeNav: 'trucks',
      showDriverSearch: false,
    };
  }

  handleInputChange = (field, value) => {
    this.setState({ [field]: value });
  };

  handleFileUpload = (field, event) => {
    const file = event.target.files[0];
    if (file) {
      this.setState({ [field]: file });
    }
  };

  removeDriver = (id) => {
    this.setState((prevState) => ({
      assignedDrivers: prevState.assignedDrivers.filter((driver) => driver.id !== id),
    }));
  };

  addNewDriver = () => {
    this.setState({ showModal: true });
  };
  setPrimaryDriver = (id) => {
    this.setState((prevState) => ({
      assignedDrivers: prevState.assignedDrivers.map((driver) => ({
        ...driver,
        isPrimary: driver.id === id,
      })),
    }));
  };

  handleTypeChange = (value) => {
    this.setState({ type: value });
  };

  removeVehiclePhoto = (id) => {
    this.setState((prevState) => ({
      vehiclePhotos: prevState.vehiclePhotos.filter((photo) => photo.id !== id),
    }));
  };

  handleSave = () => {
    alert('Truck registered successfully!');
  };

  handleBackClick = () => {
    this.props.history.goBack(); // Go back to previous page

    // this.props.history.push('/dashboard');
  };

  render() {
    const {
      vehicleType,
      vehicleNumber,
      modelMake,
      capacity,
      registrationId,
      assignedDrivers,
      type,
    } = this.state;
    const user = getLoggedUser();
    return (
      <React.Fragment>
        <main className="main-content card">
          <div className="page-header">
            <button className="button1 button1-primary" onClick={() => window.history.back()}>
              <ArrowBigLeft /> {i18n.t('dashboard')}
            </button>

            <h1>{i18n.t('equipment_registration')}</h1>
            <div className="header-actions">
              <button className="button1 button1-secondary">{i18n.t('cancel')}</button>
              <button className="btn-new" onClick={this.handleSave}>
                {i18n.t('submit')}
              </button>
            </div>
          </div>

          <div className="content-grid">
            <div className="right-column">
              <section className="card-t1 driver-assignment">
                <div
                  className="card-t1-header"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="form-group full-width section-divider">
                    <div className="card-t1-header">
                      <Users size={24} className="header-icon" />
                      <h2>Driver Assignment</h2>
                    </div>
                  </div>

                  <button className="button1 button1-primary" onClick={() => this.addNewDriver()}>
                    + New Driver
                  </button>
                </div>

                <div className="form-group">
                  <label>Add / Select Driver(s)</label>
                  <div className="driver-search-wrapper">
                    <select className="driver-search">
                      <option>Search for existing driver</option>
                    </select>
                    <button className="button1 button1-primary" onClick={() => this.addDriver()}>
                      + Add Driver
                    </button>
                  </div>
                </div>

                <div className="assigned-drivers-section">
                  <div className="form-group full-width section-divider">
                    <div className="card-t1-header">
                      <Users size={24} className="header-icon" />
                      <h2>Assigned Drivers</h2>
                    </div>
                  </div>

                  <div className="drivers-list">
                    {assignedDrivers.map((driver) => (
                      <div key={driver.id} className="driver-card">
                        <button
                          className="remove-driver"
                          onClick={() => this.removeDriver(driver.id)}
                        >
                          <X size={16} />
                        </button>
                        <img src={driver.avatar} alt={driver.name} className="driver-avatar" />
                        <div className="driver-info">
                          <h4>{driver.name}</h4>
                          <p>{driver.code}</p>
                        </div>
                        <button
                          className={`primary-badge ${driver.isPrimary ? 'active' : ''}`}
                          onClick={() => this.setPrimaryDriver(driver.id)}
                        >
                          <Star size={14} />
                          {driver.isPrimary ? 'Primary Driver' : 'Set as Primary'}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            </div>

            {/* Vehicle Details Section */}
            <section className="card-t1 vehicle-details">
              <div className="form-grid">
                <div className="form-group full-width ">
                  <div className="section-header section-divider">
                    <div className="card-t1-header">
                      <Truck size={24} className="header-icon" />
                      <h2>{i18n.t('vehicle_details')}</h2>
                    </div>

                    <div style={{ display: 'flex', gap: '5px' }}>
                      <button
                        type="button"
                        className={`button1 ${type === 'non-opal' ? 'button1-primary' : ''}`}
                        onClick={() => this.handleTypeChange('non-opal')}
                      >
                        Vehicle
                      </button>

                      <button
                        type="button"
                        className={`button1 ${type === 'non-opal' ? 'button1-primary' : ''}`}
                        onClick={() => this.handleTypeChange('opal')}
                      >
                        Equipment
                      </button>

                      <button
                        type="button"
                        className={`button1 ${type === 'non-opal' ? 'button1-primary' : ''}`}
                        onClick={() => this.handleTypeChange('opal')}
                      >
                        Workers
                      </button>
                    </div>

                    <div style={{ display: 'flex', gap: '5px' }}>
                      <button
                        type="button"
                        className={`button1 ${type === 'non-opal' ? 'button1-primary' : ''}`}
                        onClick={() => this.handleTypeChange('non-opal')}
                      >
                        NON OPAL
                      </button>

                      <button
                        type="button"
                        className={`button1 ${type === 'opal' ? 'button1-primary' : ''}`}
                        onClick={() => this.handleTypeChange('opal')}
                      >
                        OPAL
                      </button>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label>Vehicle Number</label>
                  <input
                    type="text"
                    placeholder="e.g., MH12 AB 3456"
                    value={vehicleNumber}
                    onChange={(e) => this.handleInputChange('vehicleNumber', e.target.value)}
                  />
                </div>

                <div className="form-group">
                  <label>Vehicle Type</label>
                  <select
                    value={vehicleType}
                    onChange={(e) => this.handleInputChange('vehicleType', e.target.value)}
                  >
                    <option value="">Select vehicle type</option>
                    <option value="truck">Truck</option>
                    <option value="trailer">Trailer</option>
                    <option value="tanker">Tanker</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Owner Name</label>
                  <input type="text" placeholder="enter owner name of this vehicles" />
                </div>

                <div className="form-group">
                  <label>Fleet Number</label>
                  <input type="text" placeholder="enter your fleet number" />
                </div>

                <div className="form-group">
                  <label>Model & Make</label>
                  <input
                    type="text"
                    placeholder="e.g., Tata Signa 4825.TK"
                    value={modelMake}
                    onChange={(e) => this.handleInputChange('modelMake', e.target.value)}
                  />
                </div>

                <div className="form-group">
                  <label>Capacity (KG)</label>
                  <input
                    type="text"
                    placeholder="Enter capacity"
                    value={capacity}
                    onChange={(e) => this.handleInputChange('capacity', e.target.value)}
                  />
                </div>

                <div className="form-group">
                  <label>Mulkiya Number</label>
                  <input
                    type="text"
                    placeholder="Enter Registration ID"
                    value={registrationId}
                    onChange={(e) => this.handleInputChange('registrationId', e.target.value)}
                  />
                </div>

                <div className="form-group">
                  <label>Mulkiya Expiry Date </label>
                  <input
                    type="date"
                    placeholder="Enter Registration ID"
                    value={registrationId}
                    onChange={(e) => this.handleInputChange('registrationId', e.target.value)}
                  />
                </div>
              </div>

              <div className="form-group full-width">
                <label>Registration</label>
                <div className="file-upload">
                  <Upload size={32} />
                  <p>
                    Drag & drop file or <span className="browse-link">browse</span>
                  </p>
                  <small>PDF, JPG, PNG Max 6MB</small>
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => this.handleFileUpload('registrationCopy', e)}
                  />
                </div>
              </div>

              <div className="form-group full-width">
                <label>Vehicle Photos</label>
                <div className="photo-grid">
                  <div className="photo-upload">
                    <Upload size={32} />
                    <input type="file" accept="image/*" />
                  </div>
                </div>
              </div>
            </section>

            {/* Driver Assignment Section */}
          </div>
        </main>

        <AddDriver
          show={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
          user={user}
          onPaymentComplete={() => {
            this.setState({ showModal: false });
            this.getSiteVisits();
          }}
        />
      </React.Fragment>
    );
  }
}

export default VehicleRegistration;
